export function initNewsletter() {
    //sitepart
    const forms = document.querySelectorAll('.newsletterForm');
    for(const form of forms) {
        valideForm(form);
    }

    //account form
    const accountForm = document.getElementById("newsletter_subscribe");
    if(accountForm) {
        valideForm(accountForm);
    }
}

function valideForm(form) {
    const segmentWrapper = form.querySelector(".newsletterSegments");
    if (!segmentWrapper) return;

    const segmentCheckboxes = segmentWrapper.querySelectorAll("input[type='checkbox']");
    if (!segmentCheckboxes.length) return;

    const errorMsg = document.createElement("div");
    errorMsg.className = "segment-error";
    errorMsg.style.color = "red";
    errorMsg.style.marginTop = "8px";
    errorMsg.textContent = GLOBALS.tc.newsletterError;

    form.addEventListener('submit', function(event) {
        let oneChecked = false;

        segmentCheckboxes.forEach(cb => {
            if (cb.checked) {
                oneChecked = true;
            }
        });

        if (!oneChecked) {
            event.preventDefault();
            event.stopPropagation();
            if (!segmentWrapper.querySelector(".segment-error")) {
                segmentWrapper.appendChild(errorMsg);
            }
        }
    });

    segmentCheckboxes.forEach(cb => {
        cb.addEventListener("change", function () {
            if (this.checked) {
                const existingError = segmentWrapper.querySelector(".segment-error");
                if (existingError) {
                    existingError.remove();
                }
            }
        });
    });
}